<template>
  <v-layout row wrap class="task-form-container mt-3 ">
    <input-field
      :label="$tc('Template', 1)"
      :value="taskTemplate"
      variable-name="tasksTemplates"
      input-type="other"
      size="medium"
    >
      <treeselect
        v-model="taskTemplate"
        @input="updateTaskWithTemplate"
        :options="taskTemplateOptions"
        :load-options="loadTasksTemplateOptions"
        :normalizer="taskTemplateNormalizer"
        value-format="object"
        disableFuzzyMatching
        class="form-input-select"
      />
    </input-field>
    <!-- <input-field
      :label="$tc('Type', 1)"
      :value="newTask.type"
      variable-name="id"
      input-type="other"
      size="small"
      required
    >
      <treeselect
        v-model="newTask.type"
        :options="taskTypeOptions"
        disableFuzzyMatching
        class="form-input-select"
        :disabled="!disabled"
      />
    </input-field> -->

    <input-field
      :label="$t('Title')"
      v-model="newTask.title"
      variable-name="title"
      input-type="text"
      size="medium"
      required
    />

    <input-field
      :label="$tc('Assignee', 1)"
      :value="newTask.user_assignee_id"
      variable-name="user_assignee_id"
      input-type="other"
      size="small"
    >
      <treeselect
        v-model="newTask.user_assignee_id"
        :options="userOptions"
        :disable-branch-nodes="true"
        value-consists-of="LEAF_PRIORITY"
        disableFuzzyMatching
        class="form-input-select"
      />
    </input-field>
    <input-field
      :label="$tc('Dependency', 2)"
      :value="newTask.dependencies"
      input-type="other"
      size="medium"
    >
      <treeselect
        v-model="newTask.dependencies"
        :options="dependencyOptions"
        multiple
        disableFuzzyMatching
        class="form-input-select"
      />
    </input-field>
    <input-field
      :label="$t('ApprovalType')"
      input-type="other"
      size="small"
      :value="newTask.auto_approval"
    >
      <treeselect
        :value="newTask.auto_approval"
        :options="approvalType"
        @input="updateTaskApproval($event)"
        class="form-input-select"
      />
    </input-field>
    <input-field
      :label="$t('ScheduledFor')"
      v-model="newTask.scheduled_date"
      variable-name="scheduled_date"
      input-type="datetime"
      size="small"
      :max="activityDate"
      :min="dateNow"
    />

    <input-field
      :label="$t('Cost')"
      v-model="newTask.cost"
      variable-name="cost"
      input-type="number"
      size="small"
    />
    <input-field
      :label="$tc('TimeEstimation', 1)"
      v-model="newTask.execution_time"
      variable-name="type"
      input-type="number"
      size="small"
      :field-disabled="false"
    />

    <input-field
      :label="$t('Description')"
      v-model="newTask.description"
      variable-name="description"
      input-type="textarea"
      size="medium"
    />
    <!-- <div class="mx-4" v-if="newTask.type === 'checklist'">
      <Checklist
        :task="newTask"
        @addItems="addItem"
        @editItems="editItem"
        @removeItem="removeItem"
      />
      <v-alert
        :value="disableSave"
        type="error"
        transition="scale-transition"
        class="mt-3"
      >
        {{ $t("addItemAlert") }}
      </v-alert>
    </div>
    <div class="mx-4" v-if="newTask.type === 'photo'">
      <Photo
        :task="newTask"
        @addItems="addItem"
        @editItems="editItem"
        @removeItem="removeItem"
      />
      <v-alert
        :value="disableSave"
        type="error"
        transition="scale-transition"
        class="mt-3"
      >
        {{ $t("addItemAlert") }}
      </v-alert>
    </div>
    <div v-if="newTask.type === 'text'" class="pa-3 text-width">
      <ContentText
        :task="newTask"
        @addItems="addItem"
        @editItems="editItem"
        @removeItem="removeItem"
      />
      <v-alert
        :value="disableSave"
        type="error"
        transition="scale-transition"
        class="mt-3"
      >
        {{ $t("addItemAlert") }}
      </v-alert>
    </div> -->
    <div v-if="newTask.type === 'mixed'" class="pa-3 text-width">
      <Mixed
        :task="newTask"
        @addItems="addItem"
        @editItems="editItem"
        @removeItem="removeItem"
      />
      <v-alert
        :value="disableSave"
        type="error"
        transition="scale-transition"
        class="mt-3"
      >
        {{ $t("addItemAlert") }}
      </v-alert>
    </div>
  </v-layout>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import { mapActions } from "vuex";
import Checklist from "../TaskTypes/Checklists/Checklist.vue";
import Photo from "../TaskTypes/Photos/Photo.vue";
import ContentText from "../TaskTypes/Text/ContentText.vue";
import Mixed from "../TaskTypes/Mixed/Mixed.vue";
export default {
  name: "ObjectFormTaskCreateForm",

  components: { InputField, Checklist, Photo, ContentText, Mixed },

  mixins: [activitiesTasksDataMixin],

  props: {
    newTask: {
      type: Object,
      required: true
    },
    objectLayer: {
      type: String
    },
    objectData: {
      type: Object
    },
    dependencyOptions: {
      type: Array
    }
  },

  data() {
    return {
      taskTemplate: null,
      taskTemplateOptions: null,
    };
  },

  computed: {
    /**
     * list of approval types
     */
    approvalType() {
      return [
        {
          label: this.$i18n.t("AutoApproved"),
          id: true
        },
        {
          label: this.$i18n.t("ManualApproval"),
          id: false
        }
      ];
    },
    /**
     * Disables save button if fields are not filled.
     */
    disableSave() {
      return (
        this.newTask.content.length <= 0 &&
        this.newTask.title &&
        !!this.newTask.type
      );
    },
    /**
     * gets options for treeselect
     */
    userOptions() {
      let web = [];
      let mobile = [];

      this.allUsers.forEach(user => {
        if (user.status) {
          if (user.type === "web") {
            web.push({
              id: user.id,
              label: user.first_name + " " + user.last_name,
              type: user.type
            });
          } else if (user.type === "mobile") {
            mobile.push({
              id: user.id,
              label: user.first_name + " " + user.last_name,
              type: user.type
            });
          }
        }
      });
      return [
        {
          id: "Web",
          label: this.$t("Web"),
          children: web
        },
        {
          id: "Mobile",
          label: this.$t("Mobile"),
          children: mobile
        }
      ];
    }
  },

  mounted() {
    this.loadAllUsers();
    this.newTask.type = 'mixed';
  },

  methods: {
    ...mapActions([
      "fetchWorkspaceByUUID",
      "fetchAllUsers",
      "fetchTaskTemplates"
    ]),
    /**
     * filters task templates based on properties existing in object data.
     * @returns - task templates
     */
    async loadTasksTemplateOptions({ callback }) {
      try {
        let options = await this.fetchTaskTemplates();
        this.taskTemplateOptions = this.taskFilter(options);
      } catch (err) {
        console.log(err);
      }
      callback();
    },

    taskTemplateNormalizer(node) {
      return {
        id: node.uuid,
        label: node.title
      };
    },

    dependencyNormalizer(node) {
      return {
        id: node.id,
        label: node.id + ": " + node.title
      };
    },
    addItem(item) {
      this.newTask.content.push(item);
    },
    editItem(item, itemIndex) {
      this.newTask.content.splice(itemIndex, 1, item);
    },
    removeItem(index) {
      this.newTask.content.splice(index, 1);
    },

    updateTaskWithTemplate() {
      let keysToUpdate = [
        "title",
        "description",
        "cost",
        "type",
        "execution_time",
        "content"
      ];
      for (let key of keysToUpdate) {
        if (this.taskTemplate) {
          this.newTask[key] = this.taskTemplate[key];
          this.newTask.type = 'mixed';
        } else {
          this.newTask[key] = null;
          this.newTask.type = 'mixed';
        }
      }
    },
    /**
     * updates task auto approval value
     */
    updateTaskApproval(value) {
      this.newTask.auto_approval = value;
    },

    /** Searches for all the filled properties that match the field param.
     *
     * @param {Object} object - objectData from selected object
     * @param {String} field - field to look for
     *
     */
    searchObjectField(object, field) {
      for (const [key, value] of Object.entries(object)) {
        if (typeof value === "object" && value !== null) {
          let fieldFounded = this.searchObjectField(value, field);
          if (fieldFounded) return fieldFounded;
        }
        if (key.includes(field) && value) {
          return value;
        }
      }
    },
    taskFilter(tasks) {
      let filtered = tasks.filter(task => {
        if (
          task.object_type[this.objectLayer] &&
          task.object_type[this.objectLayer].length > 0
        ) {
          let objectFilter = task.object_type[this.objectLayer].find(
            item => item.property
          );
          if (objectFilter) {
            let found = this.searchObjectField(
              this.objectData,
              objectFilter.property
            );
            if (found !== objectFilter.filter) {
              return;
            }
          }
        }
        return task.object_type[this.objectLayer];
      });
      return filtered;
    }
  }
};
</script>

<style scoped>
.text-width {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskCreate/TaskCreateForm.vue